// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchError_container__oaRGw","error":"SearchError_error__KMPUv"};